export const environment = {
  production: true,
  api: {
    baseUrl: 'https://api-noprod.jitsupedia.it',
  },
};
